import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Constants } from '../constants/constants';
import { HttpClient, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';
import { UtilService } from './/util.service';
import { NavigationOptions } from '../shared/model/navigation-options.model';
import { SmsMfaVerification } from '../shared/model/sms-mfa-verification.model';
import { isNullOrUndefined } from 'util';
import { EnvService } from './env.service';
import IdleTimer from "../IdleTimer";

@Injectable({
	providedIn: 'root'
})
export class AuthenticationService {

	readonly TOKEN_KEY;
	readonly USERNAME_STORAGE_KEY;

	flag: boolean = false;
	authenticationState = new BehaviorSubject(false);
	authenticationModel = null;
	loggedInUser = null;
	httpOption: any;
	deviceId: any;
	accountData: any;
	navigationOptions: Array<NavigationOptions> = [];
	userStatus = ["PENDING", "INVITED"];

	constructor(private http: HttpClient, private utilService: UtilService, private env: EnvService) {
		this.TOKEN_KEY = this.env.MODE + "-auth-details";
		this.USERNAME_STORAGE_KEY = this.env.MODE + "-username-storage-key";
		this.checkToken();
	}

	setHttpOption() {

		if (isNullOrUndefined(this.authenticationModel) || isNullOrUndefined(this.authenticationModel.idToken)) {
			console.log("Access token in null or undefined");
			return;
		}

		this.httpOption = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + this.authenticationModel.idToken,
				'API_KEY': Constants.API_KEY,
				'APP_TYPE': this.env.APP_TYPE
			})
		};
	}

	login(reqPayload) {
		var url = this.env.BASE_URL + Constants.LOGIN_URL;

		const httpOption = {
			headers: new HttpHeaders({
				'API_KEY': Constants.API_KEY,
				'APP_TYPE': this.env.APP_TYPE
			})
		};

		return new Promise((resolve, reject) => {
			this.http.post(url, reqPayload, httpOption).subscribe((data: any) => {
				// console.log("login response : ", data);
				this.handleLoginResponse(data, resolve);
			},
				error => {
					console.log("login error : ", error);
					reject(error);
				});
		});
	}

	resetPassword(payload: any) {
		var url = this.env.BASE_URL + Constants.NEW_PASSWORD_URL;

		const httpOption = {
			headers: new HttpHeaders({
				'API_KEY': Constants.API_KEY,
				'APP_TYPE': this.env.APP_TYPE
			})
		};

		return new Promise((resolve, reject) => {
			this.http.post(url, payload, httpOption).subscribe((data: any) => {
				// console.log("reset password response : ", data);
				this.handleLoginResponse(data, resolve);
			},
				error => {
					console.log("reset password error : ", error);
					reject(error);
				});
		});
	}

	private handleLoginResponse(data: any, resolve: (value?: unknown) => void) {
		if (data && data.authenticationResult != null) {
			this.authenticationModel = data.authenticationResult;
			this.saveAuthDetailInStorage(this.authenticationModel);
			this.getLoggedInUserDetail();
			var res = JSON.parse(JSON.stringify(data));
			resolve(res);
		}
		else {
			var response = {
				"challengeName": data["challengeName"],
				"session": data["session"],
				"username": data["challengeParameters"]["USER_ID_FOR_SRP"],
				"codeDeliveryDestination": data["challengeParameters"]["CODE_DELIVERY_DESTINATION"],
				"deliveryMedium": data["challengeParameters"]["CODE_DELIVERY_DELIVERY_MEDIUM"]
			};
			resolve(JSON.parse(JSON.stringify(response)));
		}
	}

	validateMfa(payload: SmsMfaVerification) {
		let httpOption = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				'API_KEY': Constants.API_KEY,
				'APP_TYPE': this.env.APP_TYPE
			})
		};

		var url = this.env.BASE_URL + Constants.MFA_URL;
		return new Promise((resolve, reject) => {
			this.http.post(url, payload, httpOption).subscribe((data: any) => {
				console.log("MFA response : ", data);
				if (data && data.authenticationResult) {
					this.authenticationModel = data.authenticationResult;
					this.saveAuthDetailInStorage(this.authenticationModel);
					this.getLoggedInUserDetail();
					var res = JSON.parse(JSON.stringify(data));
					resolve(res);
				} else {
					reject(data);
				}
			},
				error => {
					console.log("login error : ", error);
					reject(error);
				});
		});
	}

	forgotPassword(payload: any) {
		var url = this.env.BASE_URL + Constants.FORGOT_PASSWORD_URL;

		const httpOption = {
			headers: new HttpHeaders({
				'API_KEY': Constants.API_KEY,
				'APP_TYPE': this.env.APP_TYPE
			})
		};

		return new Promise((resolve, reject) => {
			this.http.post(url, payload, httpOption).subscribe((data: any) => {
				var res = JSON.parse(JSON.stringify(data));
				resolve(res);
			},
				error => {
					console.log("forgot password error : ", error);
					reject(error);
				});
		});
	}

	confirmForgotPassword(payload: any) {
		var url = this.env.BASE_URL + Constants.CONFIRM_PASSWORD_URL;

		const httpOption = {
			headers: new HttpHeaders({
				'API_KEY': Constants.API_KEY,
				'APP_TYPE': this.env.APP_TYPE
			})
		};

		return new Promise((resolve, reject) => {
			this.http.post(url, payload, httpOption).subscribe((data: any) => {
				var res = JSON.parse(JSON.stringify(data));
				resolve(res);
			},
				error => {
					console.log("confirm password error : ", error);
					reject(error);
				});
		});
	}

	saveAuthDetailInStorage(data) {
		if (data && data.idToken) {
			console.log("saving token in storage");
			localStorage.setItem(this.TOKEN_KEY, JSON.stringify(data));
		}
	}

	logout() {
		localStorage.removeItem(this.TOKEN_KEY);
		localStorage.removeItem(this.USERNAME_STORAGE_KEY);
		this.authenticationModel = null;
		this.loggedInUser = null;
		this.authenticationState.next(false);
		this.clearIdleTimer();
		this.utilService.hideSpinner();
		// this.storage.remove(TOKEN_KEY).then(() => {
		// 	this.authenticationModel = null;
		// 	this.loggedInUser = null;

		// 	this.authenticationState.next(false);
		// });
	}

	isUserStatusInvitedorPending() {
		var isUserStatusInvitedorPending = false;
		if (this.loggedInUser && this.loggedInUser.status && this.userStatus.includes(this.loggedInUser.status)) {
			isUserStatusInvitedorPending = true;
		}
		return isUserStatusInvitedorPending;
	}

	isAuthenticated() {
		return this.authenticationState.value;
	}

	checkToken() {
		var token = localStorage.getItem(this.TOKEN_KEY);
		if (token && token.includes("idToken")) {
			var data = JSON.parse(token);
			if (data) {
				this.authenticationModel = data;
				this.getLoggedInUserDetail();
			}
		}
	}

	private getLoggedInUserDetail() {
		this.setHttpOption();
		this.callUserDetailApi().then(() => {
			console.log("got logged in user profile");
			this.authenticationState.next(true);
			this.initIdleTimer();
		}).catch((error) => {
			if (error.status == Constants.HTTP_UNAUTHORISED) {
				this.refreshToken().then(() => {
					// this.utilService.dismissSpinner();
					console.log("refresh token api executed");
					this.getLoggedInUserDetail();
				});
			}
			else {
				alert(error.message);
				// this.utilService.dismissSpinner();
				// this.utilService.showToast(error.message, Constants.TOAST_DURATION_SHORT);
			}
		});
	}

	private callUserDetailApi(): Promise<any> {
		var url = this.env.BASE_URL + Constants.GET_USER_DETAILS;
		return new Promise((resolve, reject) => {
			this.http.get(url, this.httpOption).subscribe((data) => {
				// console.log("user detail response : ", data);
				// var res = JSON.parse(JSON.stringify(data));
				this.loggedInUser = data;
				localStorage.setItem(this.USERNAME_STORAGE_KEY, this.loggedInUser.username);
				resolve();

			},
				error => {
					console.log(error);
					reject(error);
				});
		});
	}

	callRefreshTokenApi() {
		// this.utilService.showSpinner();
		this.refreshToken().then(() => {
			// this.utilService.dismissSpinner();
			console.log("refresh token api executed");
		}).catch((errorMsg) => {
			// this.utilService.dismissSpinner();
			// this.utilService.showToast(errorMsg, Constants.TOAST_DURATION_SHORT);
			alert();
		});
	}

	refreshToken(): Promise<any> {

		if (isNullOrUndefined(this.authenticationModel) || isNullOrUndefined(this.authenticationModel.refreshToken)) {
			console.log("Refresh token in null or undefined");
			localStorage.removeItem(this.TOKEN_KEY);
			return;
		}

		var url = this.env.BASE_URL + "idm/api/refresh_token";
		const httpOption = {
			headers: new HttpHeaders({
				'API_KEY': Constants.API_KEY,
				'APP_TYPE': this.env.APP_TYPE
			})
		};

		let loggedInUser = localStorage.getItem(this.USERNAME_STORAGE_KEY);
		var reqPayload = {
			"refreshToken": this.authenticationModel.refreshToken,
			"username": loggedInUser != null ? loggedInUser : null
		};

		return new Promise((resolve, reject) => {
			this.http.post(url, reqPayload, httpOption).subscribe((data: any) => {
				this.authenticationModel = data.authenticationResult;
				this.setHttpOption();
				localStorage.removeItem(this.TOKEN_KEY);
				this.saveAuthDetailInStorage(this.authenticationModel);
				// console.log("refresh token response : ", this.authenticationModel);
				// this.storage.remove(TOKEN_KEY).then(() => {
				// 	console.log("save refresh token response : ", data);
				// 	this.saveAuthDetailInStorage(data);
				// 	console.log("refresh token response : ", data);
				// });
				resolve();
			},
				error => {
					console.log(error);
					this.logout();
					reject(error.message || Constants.UNKNOWN_ERROR);
				});
		});
	}

	getAuthenticationModel() {
		return this.authenticationModel;
	}

	isAdmin(): boolean {
		var flag: boolean = false;
		if (this.loggedInUser) {
			for (var i = 0; i < this.loggedInUser.roles.length; i++) {
				if (Constants.ROLE_ACCOUNT_ADMIN == this.loggedInUser.roles[i]) {
					flag = true;
					break;
				}
			}
		}
		return flag;
	}


	isUserRoleAllowed(): boolean {
		var flag: boolean = false;
		if (this.loggedInUser) {
			if (this.env.MODE == Constants.DEVELOPER_MODE) {
				flag = this.isDeveloper();
			} else {
				var allowedRoles = [Constants.ROLE_ACCOUNT_ADMIN, Constants.ROLE_ACCOUNT_FINANCE_USER];
				for (var i = 0; i < this.loggedInUser.roles.length; i++) {
					if (allowedRoles.includes(this.loggedInUser.roles[i])) {
						flag = true;
						break;
					}
				}
			}
		}
		return flag;
	}

	isDongleProvider(): boolean {
		var flag: boolean = false;
		if (this.loggedInUser && this.loggedInUser.roles.includes(Constants.ROLE_DONGLE_PROVIDER_ADMIN)) {
			flag = true;
		}
		return flag;
	}

	isDeveloper(): boolean {
		var flag: boolean = false;
		if (this.loggedInUser) {
			for (var i = 0; i < this.loggedInUser.roles.length; i++) {
				if (Constants.ROLE_ACCOUNT_DEVELOPER == this.loggedInUser.roles[i]) {
					flag = true;
					break;
				}
			}
		}
		return flag;
	}

	isFinanceAdmin(): boolean {
		var flag: boolean = false;
		if (this.loggedInUser && this.loggedInUser.roles.includes(Constants.ROLE_ACCOUNT_FINANCE_USER)) {
			flag = true;
		}
		return flag;
	}


	changePassword(payload: any): Promise<any> {
		var url = this.env.BASE_URL + Constants.IDM + Constants.SEPARATOR + Constants.API +
			Constants.SEPARATOR + Constants.CHANGE_PASSWORD;
		var requestParam = {
			"accessToken": this.authenticationModel.accessToken,
			"oldPassword": payload.oldPassword,
			"password": payload.password
		};
		console.log("change password request param::", requestParam);
		return new Promise((resolve, reject) => {
			this.http.post(url, requestParam, this.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				// console.log("change password : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	generateMfaOtp(): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + Constants.OEM + Constants.SEPARATOR + this.loggedInUser.enterpriseId +
			Constants.ACCOUNTS_URL + Constants.SEPARATOR + this.loggedInUser.accountId +
			Constants.USERS + Constants.SEPARATOR + this.loggedInUser.userId +
			Constants.VERIFY + Constants.PHONE;

		console.log("Generate mFA OTP URL : ", url);
		var requestParam = {
			"accessToken": this.authenticationModel.accessToken
		};
		console.log("generateMfaOtp request : ", requestParam);

		return new Promise((resolve, reject) => {
			this.http.post(url, requestParam, this.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("generateMfaOtp response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	validateLoggedinUserMfaCode(payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.ONBOARDING_URL + Constants.OEM + Constants.SEPARATOR + this.loggedInUser.enterpriseId +
			Constants.ACCOUNTS_URL + Constants.SEPARATOR + this.loggedInUser.accountId +
			Constants.USERS + Constants.SEPARATOR + this.loggedInUser.userId +
			Constants.VERIFY + Constants.PHONE + Constants.CODE;

		console.log("validateLoggedinUserMfaCode URL : ", url);
		payload.accessToken = this.authenticationModel.accessToken;
		console.log("validateLoggedinUserMfaCode request : ", payload);
		return new Promise((resolve, reject) => {
			this.http.post(url, payload, this.httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("validateLoggedinUserMfaCode response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}

	public getUserDetails(): Promise<any> {
		return this.callUserDetailApi();
	}

	resendMFACode(payload): Promise<any> {
		var url = this.env.BASE_URL + Constants.IDM + Constants.SEPARATOR + Constants.API + Constants.MFA + Constants.RESEND;
		//https://stg.conexio.life/idm/api/mfa/resend
		const httpOption = {
			headers: new HttpHeaders({
				'API_KEY': Constants.API_KEY,
				'APP_TYPE': this.env.APP_TYPE
			})
		};
		return new Promise((resolve, reject) => {
			this.http.post(url, payload, httpOption).subscribe((data) => {
				var res = JSON.parse(JSON.stringify(data));
				console.log("resendMFACode response : ", res);
				resolve(res);
			},
				error => { reject(error); });
		});
	}
	/**
	 * START: Idle Timer
	 */
	timer: IdleTimer;
	initIdleTimer() {
		if (!this.env.ENABLE_IDLE_CHECK) return;
		this.timer = new IdleTimer({
			timeout: this.env.IDLE_TIME_THRESHOLD, //expired after 10 secs
			onTimeout: () => {
				this.logout();
			}
		});
	}

	clearIdleTimer() {
	 if (!this.env.ENABLE_IDLE_CHECK) return;
	 this.timer.cleanUp();
	}
 /**
	* END: Idle Timer
	*/

	isShowDeveloperAccess(accountType) {
		console.log("accounttype::", accountType)
		// if (accountType.toLowerCase() != "VEHICLE_SERVICE_PROVIDER") {
		// 	console.log("returning false");
		// 	return false;
		// } else if (accountType.toLowerCase() == "INTERNAL_AFFILIATES") {
		// 	console.log("returning false");
		// 	return false;
		// } else {
		// 	console.log("returning true");
		// 	return true;
		// }

		if (accountType != "VEHICLE_SERVICE_PROVIDER" && accountType != "INTERNAL_AFFILIATES") {
			console.log("returning true");
			return true;
		} else {
			console.log("returning false");
			return false;
		}
	}
}

